export const TransferStatusMap: Record<number, string> = {
  0: 'New',
  1: 'In Process',
  2: 'Completed',
  3: 'Failed',
  4: 'Try Failed Transfers',
  5: 'Cancelled',
  6: 'N/A',
};

export const TransferStatusColorMap: Record<number, string> = {
  0: 'blue',
  1: 'yellow',
  2: 'green',
  3: 'red',
  4: 'orange',
  5: 'purple',
  6: 'gray',
};
